import React, { Component } from 'react';
import { Card, CardBody, CardLink, Button, Modal, ModalHeader, ModalBody, Col, Row, Label, Form, Input, CardHeader, Badge, CardText, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, FormGroup, UncontrolledTooltip } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import { ip } from '../../Auxiliares/ip'
import ModEstudiante from '../../Paginas/Admin/modEstudiante'
import modificarImg from '../../Img/modificar.png'
import eliminarImg from '../../Img/eliminar.png'
import { string } from 'prop-types';
import Banner from '../../Img/Banner.png'



export default class estudianteCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isViewModalOpen: null,
            editAspirante: null,
            isEmailModalOpen: null,
            documentos: [
                { nombre: 'Solicitud de inscripción', ref: null },
                { nombre: 'Acta de nacimiento', ref: null },
                { nombre: 'CURP', ref: null },
                { nombre: 'Documento institucional', ref: null },
                { nombre: 'Fotografía', ref: null },
                { nombre: 'Formato FM9', ref: null },
                { nombre: 'Contrato estudiantil', ref: null },
                { nombre: 'Número de seguro social', ref: null },
            ],
            nombre: null,
            verNombre: null,
            doc: null,
            ruta: null,

            _id: "",
            nombreAspirante: "",
            ap_paterno: "",
            ap_materno: "",
            curp: "",
            ficha: "",
            pago: "",
            sexo: "",
            nacionalidad: "",
            correo: "",
            convocatoria: "",
            buttonEnabled: false, //loading,
        }

        this.toggleEditAspirante = this.toggleEditAspirante.bind(this)
        this.cargarPerfil = this.cargarPerfil.bind(this)
        this.referenciar = this.referenciar.bind(this)
        this.dateToString = this.dateToString.bind(this)
        this.cambiarEstadoCuenta = this.cambiarEstadoCuenta.bind(this)
        this.estado = this.estado.bind(this)
        this.abrirDocumento = this.abrirDocumento.bind(this)
        this.verDocumento = this.verDocumento.bind(this)
        this.limpiar = this.limpiar.bind(this)
        this.correoAspirante = this.correoAspirante.bind(this)
        this.enviar = this.enviar.bind(this)
        this.uniqueId = this.uniqueId.bind(this)
    }

    componentWillMount() {
        this.cargarPerfil(this.props.aspirante.curp)
    }
    
    componentDidUpdate(prevProps) {
        console.log(this.props.aspirante)
        if(this.props.aspirante._id !== prevProps.aspirante._id){
            this.setState({buttonEnabled: false})
            this.cargarPerfil(this.props.aspirante.curp)
        }
    }

    enviar() {
        var curp = this.state.isEmailModalOpen;
        var documento = this.state.documento;
        var mensaje = this.state.mensajeCorreo;

        Fetch('/api/notificarCorreoAspirante', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ curp, documento, mensaje })
        })
            .then(response => {
                this.props.actualizarLista();
                this.correoAspirante()
                this.setState({ documento: '', mensaje: '' })
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;
                    case 602:
                        console.log('Este elemento no existe')
                        break;
                    default:
                        break;
                }
            })
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    correoAspirante(curp, documento) {
        this.setState({ isEmailModalOpen: curp ? curp : null, documento: documento })
    }

    referenciar(perfil) {
        var doc = this.state.documentos;
        doc[0].ref = perfil.solicitud;
        doc[1].ref = perfil.acta_nacimiento;
        doc[2].ref = perfil.acta_curp;
        doc[3].ref = perfil.documento_institucional;
        doc[4].ref = perfil.fotografia;
        doc[5].ref = perfil.forma_extranjero;
        doc[6].ref = perfil.contrato_estudiantil;
        doc[7].ref = perfil.nss;
        this.setState({ documentos: doc })
    }

    cargarPerfil(curp) {
        Fetch('/api/getAspirantePerfil', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ curp })
        })
            .then(response => {
                this.referenciar(response.data)
                this.setState({buttonEnabled: true})
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ perfil: null })
                        break;

                    default:
                        console.log("paso algo" + err.status)
                        break;
                }
            })

    }

    limpiar() {
        this.setState({
            nombreAspirante: "",
            ap_paterno: "",
            ap_materno: "",
            curp: "",
            ficha: "",
            pago: "",
            sexo: "",
            nacionalidad: "",
            correo: "",
            convocatoria: ""
        })
    }

    toggleView(curp) {
        if (curp) {
            this.setState({ isViewModalOpen: curp })
        } else {
            this.setState(({ isViewModalOpen: null }));
        }
        this.props.actualizarLista()
    }

    toggleEditAspirante(data) {
        if (data) {
            this.setState({ id: data._id, editAspirante: data, nombreAspirante: data.nombre, ap_paterno: data.ap_paterno, ap_materno: data.ap_materno, curp: data.curp, ficha: data.ficha, pago: data.pago, sexo: data.sexo, nacionalidad: data.nacionalidad, correo: data.correo, convocatoria: data.convocatoria })
        } else {
            this.setState({ editAspirante: null })
        }
    }

    guardarAspirante() {
        var usuario = sessionStorage.getItem("usuario")
        const { id, nombreAspirante, ap_paterno, ap_materno, curp, ficha, pago, sexo, nacionalidad, correo, convocatoria } = this.state
        Fetch('/api/updateAspirante', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, usuario, nombre: nombreAspirante, ap_paterno, ap_materno, curp, ficha, pago, sexo, nacionalidad, correo, convocatoria })
        })
            .then(response => {
                this.props.actualizarLista()
                this.toggleEditAspirante()
            })
            .catch(err => {
                switch (err.status) {
                    case 801:
                        toast.error('Nombre del aspirante invalido')
                        break;

                    case 804:
                        toast.error('Apellido paterno del aspirante invalido')
                        break;

                    case 805:
                        toast.error('Apellido materno del aspirante invalido')
                        break;

                    case 806:
                        toast.error('Curp del aspirante invalido')
                        break;

                    case 807:
                        toast.error('Error, curp ya existente')
                        break;

                    case 808:
                        toast.error('Ficha introducida invalida')
                        break;

                    case 809:
                        toast.error('Error, ficha ya existente')
                        break;

                    case 810:
                        toast.error('Convocatoria introducida invalido')
                        break;

                    case 400:
                        toast.error('Error al registrar aspirante')
                        break;

                    case 600:
                        toast.error('Error generico' + err)
                        break;

                    case 613:
                        toast.error('Error al crear el perfil de aspirante')
                        break;

                    case 612:
                        toast.error('Error al crear al aspirante')
                        break;

                    case 601:
                        toast.error('Error al crear al aspirante, curp ya registrada')
                        break;

                    default:
                        toast.error("Se produjo un error de conexion" + err)
                        break;
                }
            })
    }

    dateToString(fecha) {
        var date = new Date(fecha);
        return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }

    cambiarPago(curp, estado) {
        Fetch('/api/aspirantePago', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ curp, estado })
        })
            .then(response => {
                this.props.actualizarLista()
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        toast.error('Error inesperado')
                        break;

                    case 602:
                        toast.error('Error, este aspirante no existe')
                        break;

                    default:
                        break;
                }
            })
    }

    listaEstadoPago(curp, estado) {
        const estados = ["PENDIENTE", "RECHAZADO", "APROBADO"]
        const lista = estados.filter(est => est !== estado)

        return lista.map(elem => (<DropdownItem onClick={() => this.cambiarPago(curp, elem)} >{elem}</DropdownItem>))
    }

    abrirDocumento(elem, index) {
        if (elem) {
            this.setState({ nombre: elem.nombre, ruta: elem.ref.ruta, doc: index })
        } else {
            this.setState({ nombre: null })
        }
    }

    verDocumento(elem, index) {
        if (elem) {
            this.setState({ verNombre: elem.nombre, ruta: elem.ref.ruta, doc: index })
        } else {
            this.setState({ verNombre: null })
        }
    }

    estado(e) {
        switch (e) {
            case 'VACIO':
                return <div className="d-inline-block text-secondary">Documento vacio</div>

            case 'REVISION':
                return <div className="d-inline-block text-secondary">Documento en revision</div>

            case 'ACEPTADO':
                return <div className="d-inline-block text-success">Documento aceptado</div>

            case 'RECHAZADO':
                return <div className="d-inline-block text-danger">Documento rechazado</div>

            default:
                return <div className="d-inline-block text-danger">?</div>
                break;
        }
    }

    cambiarEstadoCuenta(curp, estado) {
        estado = !estado;

        Fetch('/api/aspiranteCuenta', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ curp, estado })
        })
            .then(response => {
                this.props.actualizarLista()
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        toast.error('Error inesperado')
                        break;

                    case 602:
                        toast.error('Error, este aspirante no existe')
                        break;

                    default:
                        break;
                }
            })
    }

    cambiarEstado(index, e) {
        var curp = this.state.isViewModalOpen;
        var estado = e.target.value;

        switch (index) {
            case 0:
                //solicitud
                Fetch('/api/updateSolicitud', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp, estado })
                })
                    .then(response => {
                        this.cargarPerfil(this.props.aspirante.curp)
                        toast.success("Estado Actualizado")
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 1:
                //acta de nacimiento
                Fetch('/api/updateActaNacimiento', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp, estado })
                })
                    .then(response => {
                        this.cargarPerfil(this.props.aspirante.curp)
                        toast.success("Estado Actualizado")
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 2:
                //curp
                Fetch('/api/updateActaCurp', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp, estado })
                })
                    .then(response => {
                        this.cargarPerfil(this.props.aspirante.curp)
                        toast.success("Estado Actualizado")

                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 3:
                //documento_institucional
                Fetch('/api/updateDocumentoInstitucional', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp, estado })
                })
                    .then(response => {
                        this.cargarPerfil(this.props.aspirante.curp)
                        toast.success("Estado Actualizado")

                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 4:
                //fotografia
                Fetch('/api/updateFotografia', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp, estado })
                })
                    .then(response => {
                        this.cargarPerfil(this.props.aspirante.curp)
                        toast.success("Estado Actualizado")

                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 5:
                //forma extranjero
                Fetch('/api/updateFormaExtranjero', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp, estado })
                })
                    .then(response => {
                        this.cargarPerfil(this.props.aspirante.curp)
                        toast.success("Estado Actualizado")

                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 6:
                //contrato estudiantil
                Fetch('/api/updateContratoEstudiantil', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp, estado })
                })
                    .then(response => {
                        this.cargarPerfil(this.props.aspirante.curp)
                        toast.success("Estado Actualizado")

                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            case 7:
                //nss
                Fetch('/api/updateNss', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp, estado })
                })
                    .then(response => {
                        this.cargarPerfil(this.props.aspirante.curp)
                        toast.success("Estado Actualizado")

                    })
                    .catch(err => {
                        switch (err.status) {
                            case 400:
                                toast.error('Error al registrar documento')
                                break;

                            case 600:
                                toast.error('Error generico' + err)
                                break;

                            case 614:
                                toast.error('Error al actualizar información')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    })
                break;

            default:
                break;
        }
    }

    comboEstado(elem, index) {
        const estados = ['VACIO', 'REVISION', 'ACEPTADO', 'RECHAZADO']
        const tipos = ['CONSTANCIA_TERMINACION_ESTUDIOS', 'HISTORIAL_ACADEMICO', 'CERTIFICADO_PREPARATORIA', 'REVALIDACION_ESTUDIOS', 'CARTA_COMPROMISO']

        var estado = elem.ref.estado;
        var i = estados.indexOf(estado);
        delete estados[i];

        var tipo = elem.ref.tipo ? elem.ref.tipo : null;
        var i2 = tipos.indexOf(tipo);
        delete tipos[i2];

        return (
            elem.nombre != "Documento institucional" ?
                <tr>
                    <th>{elem.nombre}</th>
                    <th>{
                        <Input type="select" onChange={(e) => this.cambiarEstado(index, e)}>
                            <option disabled>Estado</option>
                            <option selected>{estado}</option>
                            {estados.map(e => (
                                <option>{e}</option>
                            ))}
                        </Input>}
                    </th>
                    <th>{elem.ref.ruta != null ? <Button outline color="info" size="sm" onClick={() => this.verDocumento(elem, index)}> Ver Documento </Button> : ""}
                    </th>
                </tr>
                :
                <tr>
                    <th>{elem.nombre}</th>
                    <th>{
                        <Input type="select" onChange={(e) => this.cambiarEstado(index, e)}>
                            <option disabled>Estado</option>
                            <option selected>{estado}</option>
                            {estados.map(e => (
                                <option>{e}</option>
                            ))}
                        </Input>}
                    </th>
                    <th>{
                        <Input type="select" onChange={(e) => this.cambiarTipo(e)}>
                            <option disabled>Tipo</option>
                            <option selected>{tipo}</option>
                            {tipos.map(e => (
                                <option>{e}</option>
                            ))}
                        </Input>
                    }</th>
                    <th>{elem.ref.ruta != null ? <Button outline color="info" size="sm" onClick={() => this.verDocumento(elem, index)}> Ver Documento </Button> : ""}</th>
                </tr>

        )
    }

    cambiarTipo(e) {
        var curp = this.state.isViewModalOpen;
        var tipo = e.target.value;

        Fetch('/api/updateTipoDocumentoInstitucional', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ curp, tipo })
        })
            .then(response => {
                toast.success("Tipo Actualizado")
            })
            .catch(err => {
                switch (err.status) {
                    case 400:
                        toast.error('Error al registrar documento')
                        break;

                    case 600:
                        toast.error('Error generico' + err)
                        break;

                    case 614:
                        toast.error('Error al actualizar información')
                        break;

                    default:
                        toast.error("Se produjo un error de conexion" + err)
                        break;
                }
            })
    }

    uniqueId(ficha, index) {
        var cad = "#" + ficha + index
        return cad
    }


    render() {
        return (
            <div>
                <Card className="w-100 mt-3" >
                    <CardHeader>
                        <Row>
                            <Col xs="12" xl="9">
                                <Row>
                                    <Col> Ficha #{this.props.aspirante.ficha} </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {this.state.documentos[0].ref != null ? this.state.documentos.map((docs, index) => (
                                            <Badge id="example" color={docs.ref.estado == "ACEPTADO" ? "success" : docs.ref.estado == "RECHAZADO" ? "danger" : docs.ref.estado == "REVISION" ? "warning" : "dark"} pill> </Badge>
                                        )) : "VACIO"}
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs="12" xl="3" className="mb-2">
                                <Button block onClick={() => this.toggleEditAspirante(this.props.aspirante)} className="bg-warn d-inline-block">&#128393;</Button>
                            </Col>
                            <Col xs="12">
                                {this.state.buttonEnabled ?
                                <Button block onClick={() => this.toggleView(this.props.aspirante.curp)} className="bg-primary d-inline-block">Archivo</Button>
                                : 
                                <Button block disabled onClick={() => this.toggleView(this.props.aspirante.curp)} className="bg-primary d-inline-block">Archivo</Button>
                                }
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className="text-left btn">
                        <CardText><p><div className="d-inline-block font-weight-bold small">Nombre:</div> {this.props.aspirante.nombre} {this.props.aspirante.ap_paterno} {this.props.aspirante.ap_materno}</p></CardText>
                        <CardText><p><div className="d-inline-block font-weight-bold small">Ultima sesión:</div> {this.props.aspirante.ultima_sesion !== undefined ? this.dateToString(this.props.aspirante.ultima_sesion) : "NUNCA"}</p></CardText>
                        <CardText><p><div className="d-inline-block font-weight-bold small">Pago:</div> <UncontrolledButtonDropdown> <DropdownToggle caret size="md">{this.props.aspirante.pago}</DropdownToggle><DropdownMenu> {this.listaEstadoPago(this.props.aspirante.curp, this.props.aspirante.pago)} </DropdownMenu></UncontrolledButtonDropdown></p></CardText>
                        <CardText><p><div className="d-inline-block font-weight-bold small">Cuenta: </div> <Button onClick={() => this.cambiarEstadoCuenta(this.props.aspirante.curp, this.props.aspirante.cuentaActiva)}>{this.props.aspirante.cuentaActiva ? 'ACTIVADA' : 'DESACTIVADA'}</Button></p></CardText>
                    </CardBody>
                </Card>

                <Modal isOpen={this.state.isViewModalOpen !== null} toggle={() => this.toggleView()}
                    className="modal-xl">
                    <ModalHeader
                        style={{
                            background: `url(${Banner}) center`,
                            backgroundSize: 'cover', backgroundPosition: 'center-left',
                        }}
                        toggle={() => this.toggleView()}><h5 className="text-light">{this.state.isViewModalOpen !== null ? this.state.isViewModalOpen : ''}</h5></ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Row>
                                    <Col className="col-12">
                                        <table class="table table-hover">
                                            <thead class="bg-info thead-dark">
                                                <tr>
                                                    <th> Documento </th>
                                                    <th> Estado </th>
                                                    <th>  </th>
                                                </tr>
                                            </thead>

                                            {this.state.documentos[0].ref !== null ? this.state.documentos.map((elem, index) => (
                                                <tbody>
                                                    {this.comboEstado(elem, index)}
                                                </tbody>
                                            )) : 'VACIO'}
                                        </table>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>


                <Modal isOpen={this.state.editAspirante != null} toggle={() => this.toggleEditAspirante()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleEditAspirante()}>Editar Aspirante</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    <FormGroup >
                                        <Input className="w-100" type="text" onChange={this.setValue.bind(this, "nombreAspirante")} placeholder="Nombre" name="nombre" defaultValue={this.state.nombreAspirante} />
                                    </FormGroup>

                                    <FormGroup>
                                        <Input className="w-100" type="text" onChange={this.setValue.bind(this, "ap_paterno")} placeholder="Apellido Paterno" name="ap_paterno" defaultValue={this.state.ap_paterno} />
                                    </FormGroup>

                                    <FormGroup>
                                        <Input className="w-100" type="text" onChange={this.setValue.bind(this, "ap_materno")} placeholder="Apellido Materno" name="ap_materno" defaultValue={this.state.ap_materno} />
                                    </FormGroup>

                                    <FormGroup>
                                        <Input className="w-100" type="text" onChange={this.setValue.bind(this, "curp")} placeholder="CURP" name="curp" defaultValue={this.state.curp} />
                                    </FormGroup>

                                    <FormGroup>
                                        <Input className="w-100" type="number" onChange={this.setValue.bind(this, "ficha")} placeholder="Ficha" name="ficha" defaultValue={this.state.ficha} />
                                    </FormGroup>

                                    <FormGroup>
                                        <Input type="select" name="pago" onChange={this.setValue.bind(this, "pago")} className="w-100" value={this.state.pago}>
                                            <option disabled>Pago</option>
                                            <option value="PENDIENTE">Pendiente</option>
                                            <option value="RECHAZADO">Rechazado</option>
                                            <option value="APROBADO">Aprobado</option>
                                        </Input>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input type="select" name="sexo" onChange={this.setValue.bind(this, "sexo")} className="w-100" value={this.state.sexo}>
                                            <option disabled>Sexo</option> {/* Mandarlo como M = Maxculino o F = Femenino */}
                                            <option value="M">Hombre</option> {/* Mandarlo como M = Maxculino o F = Femenino */}
                                            <option value="F">Mujer</option>
                                        </Input>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input type="select" name="nacionalidad" onChange={this.setValue.bind(this, "nacionalidad")} className="w-100" value={this.state.nacionalidad}>
                                            <option disabled>Nacionalidad</option> {/* Mandarlo como M = Maxculino o F = Femenino */}
                                            <option value="M">Mexicana</option> {/* Mandarlo como M = Maxculino o F = Femenino */}
                                            <option value="E">Extranjero</option>
                                        </Input>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input className="w-100" type="text" onChange={this.setValue.bind(this, "correo")} placeholder="Correo" name="correo" defaultValue={this.state.correo} />
                                    </FormGroup>

                                    <FormGroup>
                                        <Input type="select" name="convocatoria" onChange={this.setValue.bind(this, "convocatoria")} className="w-100" value={this.state.convocatoria}>
                                            <option disabled>Convocatoria</option> {/* Mandarlo como M = Maxculino o F = Femenino */}
                                            {this.props.convocatorias.map(elem => (
                                                <option value={elem.convocatoria}>{elem.convocatoria}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>

                                    <CardBody>
                                        <CardLink><Button className="btn-info" onClick={() => this.guardarAspirante()}>Guardar</Button></CardLink>
                                        <CardLink><Button className="btn-light" onClick={() => this.toggleEditAspirante()}>Cancelar</Button></CardLink>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.nombre !== null} toggle={() => this.abrirDocumento()}
                    className="modal-xl">
                    <ModalHeader toggle={() => this.abrirDocumento()}>{this.state.nombre !== null ? this.state.nombre : ''}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card>
                                    <Row>
                                        <Col className="text-center">
                                            <iframe
                                                title="PDF viewer"
                                                width="100%"
                                                height="625"
                                                src={ip + this.state.ruta}
                                                scrolling="no">
                                            </iframe>
                                        </Col>
                                    </Row>

                                    <Row className=" text-center">
                                        <Col>
                                            <Button className="btn-success w-100" onClick={() => this.aceptar(this.state.isViewModalOpen !== null ? this.state.isViewModalOpen : 'vacio', this.state.doc !== null ? this.state.doc : 0)}>Confirmar</Button>
                                        </Col>
                                        <Col>
                                            <Button className="btn-secondary w-100" onClick={() => this.denegar(this.state.isViewModalOpen !== null ? this.state.isViewModalOpen : 'vacio', this.state.doc !== null ? this.state.doc : 0)}>Eliminar</Button>
                                        </Col>
                                    </Row>

                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.verNombre !== null} toggle={() => this.verDocumento()}
                    className="modal-xl">
                    <ModalHeader toggle={() => this.verDocumento()}>{this.state.nombre !== null ? this.state.nombre : ''}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card>
                                    <Row>
                                        <Col className="text-center">
                                            <iframe
                                                title="PDF viewer"
                                                width="100%"
                                                height="625"
                                                src={ip + this.state.ruta}
                                                scrolling="no">
                                            </iframe>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isEmailModalOpen !== null} toggle={() => this.correoAspirante()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.correoAspirante()}>Notificar mediante correo electronico</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    <Form>
                                        <Row>
                                            <Col>
                                                <Input type="text" name="documento" onChange={() => this.setValue(this, 'mensajeCorreo')} value={this.state.mensajeCorreo} className="w-100" />
                                            </Col>
                                        </Row>

                                        <Row className="text-center px-3">
                                            <Button name="notificar" value="Enviar" className="w-100 mt-2 bg-info text-light" onClick={this.enviar}>Enviar</Button>
                                        </Row>
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

            </div>
        )
    }
}